/* eslint-disable react/jsx-no-target-blank */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { userAccountMenuConstants, userAccountContentConstants } from '../utils/user-account-constants';
import { domainConstants } from '../utils/constants/domain-constants';
import { shouldDisplayResaleButton } from '../forms/resale-tickets/resale-tickets-helpers';
import { shouldDisplayRAMembersPortalSection } from '../forms/ra-members-portal/ra-members-portal-helpers';

function AccountMenuLinks({
    userAccountData,
    accountFormData,
    ssoDomain,
    displayResaleTicketsMenuItem,
    componentToRender,
    toggleDisplayMenu,
    handleChangeAccountDetailsContent
}) {
    const isWomensOpen = ssoDomain === domainConstants.womensOpen;

    function displayAccountMenu() {
        const accountMenu = userAccountMenuConstants.map((menuItem) => {
            const theOneClubChildItem = menuItem.children.find((x) => x.form.includes(userAccountContentConstants.theOneClub));
            const resaleTicketsChildItem = menuItem.children.find((x) => x.form.includes(userAccountContentConstants.resaleTickets));
            const raMembersPortalChildItem = menuItem.children.find((x) => x.form.includes(userAccountContentConstants.raMembersPortal));
            if (!isEmpty(theOneClubChildItem) && isWomensOpen) {
                return null;
            }

            if (!isEmpty(resaleTicketsChildItem) && !displayResaleTicketsMenuItem) {
                return null;
            }
            if (!isEmpty(resaleTicketsChildItem)) {
                const isUserMatchCriteria = doesUserMatchCriteria();
                if (!isUserMatchCriteria) {
                    return null;
                }
            }

            if (!isEmpty(raMembersPortalChildItem)) {
                const isUserMatchCriteria = doesUserMatchRAMemberCriteria();
                if (!isUserMatchCriteria) {
                    return null;
                }
            }

            return (<ul key={menuItem.id} className='account-settings'>
                <li className='title'>{menuItem.title}</li>
                {displayMenuChildren(menuItem)}
            </ul>);
        });

        return <div className='categories'>{accountMenu}</div>;
    }

    function doesUserMatchCriteria() {
        const { ballotCriteria } = userAccountData;
        const { membership } = userAccountData;

        const { displayResaleCriteria } = accountFormData.ssoAccountResaleTicketsFields;

        return shouldDisplayResaleButton(displayResaleCriteria, ballotCriteria, membership);
    }

    function doesUserMatchRAMemberCriteria() {
        const { raMemberId } = userAccountData;

        const { raMembersPortalCriteria } = accountFormData.ssoraMembersPortalFields;

        return shouldDisplayRAMembersPortalSection(raMembersPortalCriteria, raMemberId);
    }

    const displayMenuChildren = (menuItem) => {
        return menuItem.children.map((childItem) => {
            const newUrl = `${window.location.pathname}#${childItem.form}`;
            return (
                <li key={childItem.id} className='item'>
                    <a href={newUrl}
                        onMouseDown={(e) => {
                            if (!e.ctrlKey && !e.metaKey && e.button === 0) {
                                e.preventDefault();
                                window.history.pushState(null, '', newUrl);
                                handleChangeAccountDetailsContent(e, childItem.form);
                                toggleDisplayMenu();
                            } else {
                                window.open(`?componentToRender=${childItem.form}`, '_blank', 'noopener,noreferrer');
                            }
                        }}
                        className={getActiveClassName(childItem.form)}>
                        {childItem.title}
                    </a>
                </li>);
        });
    };

    function getActiveClassName(accountDetailsLink) {
        if (accountDetailsLink === componentToRender) {
            return 'active';
        }

        return '';
    }

    return (<Fragment>
        {displayAccountMenu()}
        <div className='footer'>
            {isWomensOpen ?
                <a href='https://www.aigwomensopen.com/' target='_blank'><img src='../../../../../../../images/logo-aigwo-light.svg' alt='AIG Womens Open' /></a> :
                <a href='https://www.theopen.com/' target='_blank'><img src='../../../../../../../images/logo-open.svg' alt='The Open' /></a>}
            <a href='https://www.randa.org/' target='_blank'><img src='../../../../../../../images/the-randa-logo-vector-white-blue.svg' alt='Randa' /></a>
            <a href='https://oneclub.golf/' target='_blank'><img src='../../../../../../../images/oneclub-mastercard-logo.png' alt='OneClub' /></a>
        </div>
    </Fragment>
    );
}

AccountMenuLinks.propTypes = {
    userAccountData: PropTypes.object.isRequired,
    ssoDomain: PropTypes.string.isRequired,
    displayResaleTicketsMenuItem: PropTypes.bool.isRequired,
    shouldDisplayMenu: PropTypes.bool.isRequired,
    toggleDisplayMenu: PropTypes.func,
    componentToRender: PropTypes.string.isRequired,
    handleChangeAccountDetailsContent: PropTypes.func.isRequired
};

export default AccountMenuLinks;
